<footer class="site-footer">
  <div class="site-footer__inner container-fluid">
    <div class="site-footer__grid">
      <details class="site-footer__section site-footer__section--support" [open]="isSectionOpen(true)">
        <summary class="site-footer__heading">Atención al cliente</summary>
        <div class="site-footer__section-body">
          <p class="site-footer__contact-line">
            <span class="site-footer__label">Teléfono:</span>
            <a [href]="'tel:' + config.customerSupportPhone.replace(/\s/g, '')">
              {{ config.customerSupportPhoneDisplay }}
            </a>
          </p>

          <div class="site-footer__hours">
            <i class="pi pi-clock" aria-hidden="true"></i>
            <div class="site-footer__hours-lines">
              @for (line of config.customerSupportHours.scheduleLines; track line) {
                <p>{{ line }}</p>
              }
            </div>
          </div>

          <p class="site-footer__contact-line">
            <span class="site-footer__label">Email:</span>
            <a [href]="'mailto:' + config.customerSupportEmail">
              {{ config.customerSupportEmail }}
            </a>
          </p>
        </div>
      </details>

      <details class="site-footer__section site-footer__section--apps" [open]="isSectionOpen(false)">
        <summary class="site-footer__heading site-footer__heading--apps">{{ config.tenantAppDownload.title }}</summary>
        <div class="site-footer__section-body">
          <app-app-download [config]="config.tenantAppDownload" [compact]="true" />
        </div>
      </details>

      <details class="site-footer__section" [open]="isSectionOpen(false)">
        <summary class="site-footer__heading">Información legal</summary>
        <div class="site-footer__section-body">
          <nav class="site-footer__links" aria-label="Enlaces legales">
            <a [href]="config.legalNoticeUrl" target="_blank" rel="noopener noreferrer">Aviso legal</a>
            <a [href]="config.privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Política de privacidad</a>
          </nav>
        </div>
      </details>

      <details class="site-footer__section" [open]="isSectionOpen(false)">
        <summary class="site-footer__heading">Síguenos</summary>
        <div class="site-footer__section-body">
          <nav class="site-footer__social-links" aria-label="Redes sociales">
            @for (social of config.socialLinks; track social.url) {
              <a
                [href]="social.url"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="social.label"
                [title]="social.label"
              >
                <i [class]="social.icon" aria-hidden="true"></i>
              </a>
            }
          </nav>
        </div>
      </details>
    </div>

    <p class="site-footer__copy">
      © {{ currentYear }} {{ config.copyrightText }}
    </p>
  </div>
</footer>
